/**
 * Detect API / UI errors caused by RBAC (403 Insufficient permissions).
 */
export function isInsufficientPermissionError(error) {
  if (!error) return false;

  const status = error.status ?? error?.response?.status;
  if (status === 403) return true;

  const message = String(
    error.message ||
      error?.response?.data?.error ||
      error?.response?.data?.message ||
      '',
  ).toLowerCase();

  return message.includes('insufficient permission');
}
